import {
  TextInput as MantineTextInput,
  TextInputProps as MantineTextInputProps,
} from "@mantine/core";
import clsx from "clsx";
import { forwardRef, Ref } from "react";

import { selectInputOnFocus } from "#shared/helpers/selectInputOnFocus";

import classes from "./InputStyles.module.css";

export type TextInputProps = MantineTextInputProps & { highlight?: boolean };

export const TextInput: React.FunctionComponent<TextInputProps> = forwardRef(
  ({ highlight, ...props }, ref: Ref<HTMLInputElement> | undefined) => {
    return (
      <MantineTextInput
        ref={ref}
        onFocus={selectInputOnFocus}
        {...props}
        classNames={{
          input: clsx([classes.input, highlight && classes.highlight]),
          label: classes.label,
        }}
      />
    );
  },
);
